import React from "react";
import {
  FooterContainer,
  FooterSubscription,
  FooterSubHeading,
  FooterSubText,
  FooterLinksContainer,
  FooterLinksWrapper,
  FooterLinkItems,
  FooterLinkTitle,
  FooterLink,
  SocialMedia,
  SocialMediaWrap,
  SocialLogo,
  WebsiteRights,
  SocialIcons,
  SocialIconLink,
} from "./Footer.elements";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";

const Footer = () => {
  return (
    <FooterContainer>
      <FooterSubscription>
        <FooterSubHeading>Connect With Us</FooterSubHeading>
        <FooterSubText>And Fallow Us On Social Media</FooterSubText>
      </FooterSubscription>
      <FooterLinksContainer>
        <FooterLinksWrapper>
          <FooterLinkItems>
            <FooterLinkTitle>Domestic</FooterLinkTitle>
            <FooterLink to="https://en.wikipedia.org/wiki/Rakia">
              Rakija - Fruit Brandy
            </FooterLink>
            <FooterLink to="https://en.wikipedia.org/wiki/Serbian_cheeses">
              Cheese
            </FooterLink>
            <FooterLink to="https://en.wikipedia.org/wiki/Suho_meso#:~:text=Suho%20meso%20(literally%3A%20%22dry,on%20the%20size%20of%20meat.">
              Cured Meat
            </FooterLink>
            <FooterLink to="https://en.wikipedia.org/wiki/Varenye">
              Fruit Products
            </FooterLink>
          </FooterLinkItems>
          <FooterLinkItems>
            <FooterLinkTitle>Events</FooterLinkTitle>
            <FooterLink to="https://agrobelgrade.com/homepage/">
              Agro Belgrade
            </FooterLink>
            <FooterLink to="https://mojgradsm.rs/sremski-poljoprivredni-sajam/agro-sirm/">
              Agro Sirm
            </FooterLink>
            <FooterLink to="https://www.instagram.com/azzarobelville/">
              Fridays at Azzaro
            </FooterLink>
            <FooterLink to="https://www.instagram.com/p/CQOGCi0p0-O/">
              Urban Markets
            </FooterLink>
          </FooterLinkItems>
        </FooterLinksWrapper>
        <FooterLinksWrapper>
          <FooterLinkItems>
            <FooterLinkTitle>Partners</FooterLinkTitle>
            <FooterLink to="https://destilista.com">
              Melodija Distillery
            </FooterLink>
            <FooterLink to="https://mlekara.select-milk.com/en/home-2/">
              Select Milk
            </FooterLink>
            <FooterLink to="https://www.instagram.com/mesnaindustrijakosanovic/?hl=en">
              Kosanović
            </FooterLink>
            <FooterLink to="https://www.instagram.com/plodovi_mog_imanja/?hl=en">
              Plodovi Mog Imanja
            </FooterLink>
          </FooterLinkItems>
          <FooterLinkItems>
            <FooterLinkTitle>Social Media</FooterLinkTitle>
            <FooterLink to="https://www.instagram.com/serbeatplatform/?hl=en">
              SerBeat Platform
            </FooterLink>
            <FooterLink to="https://www.facebook.com/">Facebook</FooterLink>
            <FooterLink to="https://www.youtube.com/">You Tube</FooterLink>
            <FooterLink to="https://www.linkedin.com/">LinkedIn</FooterLink>
          </FooterLinkItems>
        </FooterLinksWrapper>
      </FooterLinksContainer>
      <SocialMedia>
        <SocialMediaWrap>
          <SocialLogo to="/">
            <img
              src="./logo.png"
              alt=""
              width="120px"
              height="20px"
              style={{ borderRadius: "1px" }}
            />
          </SocialLogo>
          <WebsiteRights>SERBEAT © 2026</WebsiteRights>
          <SocialIcons>
            <SocialIconLink
              href="https://www.instagram.com/serbeatplatform/?hl=en"
              target="_blank"
              aria-label="Instagram"
            >
              <FaInstagram />
            </SocialIconLink>
            <SocialIconLink
              href="https://www.facebook.com/"
              target="_blank"
              aria-label="Facebook"
            >
              <FaFacebook />
            </SocialIconLink>
            <SocialIconLink
              href="https://www.youtube.com/results?search_query=serbian+food+brands"
              target="_blank"
              aria-label="You Tube"
            >
              <FaYoutube />
            </SocialIconLink>
            <SocialIconLink
              href="https://www.linkedin.com/"
              target="_blank"
              aria-label="LinkeIn"
            >
              <FaLinkedinIn />
            </SocialIconLink>
          </SocialIcons>
        </SocialMediaWrap>
      </SocialMedia>
    </FooterContainer>
  );
};

export default Footer;
